import { render, staticRenderFns } from "./mobileB.vue?vue&type=template&id=1cc14b44&scoped=true&"
import script from "./mobileB.vue?vue&type=script&lang=js&"
export * from "./mobileB.vue?vue&type=script&lang=js&"
import style0 from "./mobileB.vue?vue&type=style&index=0&id=1cc14b44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc14b44",
  null
  
)

export default component.exports